let cookies = {
  delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    if (cval != null)
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  },
  //使用示例
  // setCookie("name", "hayden");
  // alert(getCookie("name"));
  //如果需要设定自定义过期时间
  //那么把上面的setCookie　函数换成下面两个函数就ok;
  //程序代码
  getsec(str) {
    var str1 = str.substring(1, str.length) * 1;
    var str2 = str.substring(0, 1);
    if (str2 == "s") {
      return str1 * 1000;
    } else if (str2 == "h") {
      return str1 * 60 * 60 * 1000;
    } else if (str2 == "d") {
      return str1 * 24 * 60 * 60 * 1000;
    }
  },

  getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return null;
    }
  },
  // var username = document.cookie.split(";")[0].split("=")[1];
  //JS操作cookies方法!
  //写cookies
  setCookie(name, value, timer) {
    var Days = timer;
    var exp = new Date();
    exp.setTime(exp.getTime() + parseInt(Days * 24 * 60 * 60 * 1000));
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  }

}
module.exports = cookies



// WEBPACK FOOTER //
// ./src/api/cookies.js